import script from "./BaseSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSelect.vue?vue&type=script&setup=true&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=79f9da8f&scoped=true&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f9da8f"]])

export default __exports__